// Copyright 2022 Amazon.com, Inc. or its affiliates. All Rights Reserved.
export enum BrowserType {
  APPSTREAM = "AppStream",
}
